<template>
  <div class="insurance-table">
    <vxe-table
      ref="vxeTableRef"
      :data="pageData"
      border
      auto-resize
      :column-config="{ resizable: true }"
      :row-config="{ isHover: true, height: 40 }"
      :expand-config="{ trigger: 'cell', padding: 12 }"
      :show-overflow="'title'"
      @toggle-expand="handleToggleExpand"
    >
      <vxe-column type="expand" width="50" fixed="left">
        <template #content="{ row }">
          <vxe-table
            ref="childTableRef"
            :data="row.children || []"
            border
            size="small"
            auto-resize
            :column-config="{ resizable: true }"
            :row-config="{ isHover: true, height: 40 }"
            :expand-config="{ trigger: 'cell', padding: 12 }"
          >
              <vxe-column type="expand" width="50" fixed="left">
                <template #content="{ row: childRow }">
                  <div class="expand-detail-wrapper">
                    <div class="expand-detail-title">关联套餐信息</div>
                    <div class="policies-container">
                      <template v-for="(policy, index) in getPolicies(childRow)">
                        <div :key="'item-' + index" class="policy-item">
                          <span class="policy-field">
                            <span class="expand-detail-label">保单号</span>
                            <span class="expand-detail-value">{{ policy.policyNo || '-' }}</span>
                          </span>
                          <span class="policy-field">
                            <span class="expand-detail-label">保险公司</span>
                            <span class="expand-detail-value">{{ policy.insuranceCompany || '-' }}</span>
                          </span>
                          <span class="policy-field">
                            <span class="expand-detail-label">投保人</span>
                            <span class="expand-detail-value">{{ policy.policyHolder || '-' }}</span>
                          </span>
                          <span class="policy-field">
                            <span class="expand-detail-label">被保人</span>
                            <span class="expand-detail-value">{{ formatArrayValue(policy.insured) || '-' }}</span>
                          </span>
                          <span class="policy-field">
                            <span class="expand-detail-label">销售价</span>
                            <span class="expand-detail-value">{{ policy.salesPrice || '-' }}</span>
                          </span>
                          <span class="policy-field">
                            <span class="expand-detail-label">生效日期</span>
                            <span class="expand-detail-value">{{ policy.effectiveDate || '-' }}</span>
                          </span>
                        </div>
                        <div v-if="index < getPolicies(childRow).length - 1" :key="'divider-' + index" class="policy-divider"></div>
                      </template>
                    </div>
                  </div>
                </template>
              </vxe-column>
              <vxe-column field="productName" title="套餐产品名称" min-width="150" fixed="left" />
              <vxe-column field="workLocation" title="客户工作地点" min-width="200">
                <template #default="{ row: childRow }">
                  <span>{{ getWorkLocationDisplay(childRow) }}</span>
                </template>
              </vxe-column>
              <vxe-column field="projectType" title="项目类型" min-width="120" />
              <vxe-column field="billingCycle" title="销售账单周期" min-width="130" />
              <vxe-column field="accountingEntity" title="核算主体" min-width="180" />
              <vxe-column field="enabled" title="是否启用" min-width="120">
                <template #default="{ row: childRow }">
                  <a-switch
                    v-model="childRow.enabled"
                    checked-children="启用"
                    un-checked-children="停用"
                    size="small"
                    @change="handleEnabledChange(childRow)"
                  />
                </template>
              </vxe-column>
              <vxe-column title="操作" width="120" fixed="right" align="center">
                <template #default="{ row }">
                  <button class="link-button" @click="handleHistoryPolicy(row)">历史保单</button>
                </template>
              </vxe-column>
            </vxe-table>
        </template>
      </vxe-column>
      <vxe-column type="seq" width="60" title="序号" fixed="left" />
      <vxe-column field="projectName" title="项目名称" min-width="150" />
      <vxe-column field="customerName" title="客户/装卸项目名称" min-width="200" />
      <vxe-column field="businessType" title="业务类型" width="100" />
      <vxe-column field="customerManager" title="客服专员" min-width="100" />
      <vxe-column field="cooperationStatus" title="合作状态" width="160">
        <template #default="{ row }">
          <a-select
            :value="row.cooperationStatus"
            style="width: 120px"
            @change="(val) => handleCooperationStatusChange(row, val)"
          >
            <a-select-option value="合作中">
              <a-badge status="success" />合作中
            </a-select-option>
            <a-select-option value="已终止">
              <a-badge status="error" />已终止
            </a-select-option>
          </a-select>
        </template>
      </vxe-column>
      <vxe-column title="操作" width="120" fixed="right" align="right">
        <template #default="{ row }">
          <button class="link-button" @click="handleEdit(row)">编辑</button>
          <button class="link-button" @click="handleView(row)">查看</button>
          <button
            v-if="row.cooperationStatus === '已终止'"
            class="link-button delete-link-button"
            @click="handleDelete(row)"
          >删除</button>
        </template>
      </vxe-column>
    </vxe-table>
    <div class="pagination-wrapper">
      <a-pagination
        v-model="currentPage"
        :page-size="pageSize"
        :page-size-options="['10', '20', '50', '100']"
        :total="totalCount"
        :showSizeChanger="true"
        :showQuickJumper="true"
        :showTotal="showTotalText"
        @change="handlePageChange"
        @showSizeChange="handlePageSizeChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsuranceTable',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    filterValues: {
      type: Object,
      default: () => ({
        projectName: '',
        customerName: '',
        businessType: '',
        cooperationStatus: ''
      })
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      cooperationStatusOptions: ['合作中', '已终止']
    }
  },
  computed: {
    filteredData() {
      let data = this.tableData && Array.isArray(this.tableData) ? [...this.tableData] : []
      
      if (this.filterValues && this.filterValues.projectName) {
        data = data.filter(item => item && item.projectName === this.filterValues.projectName)
      }
      if (this.filterValues && this.filterValues.customerName) {
        data = data.filter(item => item && item.customerName === this.filterValues.customerName)
      }
      if (this.filterValues && this.filterValues.businessType) {
        data = data.filter(item => item && item.businessType === this.filterValues.businessType)
      }
      if (this.filterValues && this.filterValues.cooperationStatus) {
        data = data.filter(item => item && item.cooperationStatus === this.filterValues.cooperationStatus)
      }
      
      return data.sort((a, b) => {
        const timeA = a && a.createTime || '1970-01-01 00:00:00'
        const timeB = b && b.createTime || '1970-01-01 00:00:00'
        return timeB.localeCompare(timeA)
      })
    },
    totalCount() {
      return this.filteredData ? (this.filteredData.length || 0) : 0
    },
    pageData() {
      const pageSizeNum = parseInt(this.pageSize, 10) || 10
      const start = (this.currentPage - 1) * pageSizeNum
      const end = start + pageSizeNum
      return this.filteredData ? this.filteredData.slice(start, end) : []
    }
  },
  watch: {
    tableData: {
      handler() {
        if (this.currentPage > 1 && (!this.pageData || this.pageData.length === 0)) {
          this.currentPage = 1
        }
      },
      deep: true
    },
    filterValues: {
      handler() {
        this.currentPage = 1
      },
      deep: true
    }
  },
  methods: {
    getWorkLocationDisplay(row) {
      if (row.workLocationList && Array.isArray(row.workLocationList) && row.workLocationList.length > 0) {
        return row.workLocationList.map(item => `${item.workLocation || '-' }（客服：${item.customerService || '-' }）`).join('；')
      }
      if (row.workLocation) {
        const customerService = row.customerService || row.customerManager || ''
        if (Array.isArray(row.workLocation)) {
          const locations = row.workLocation.join('、')
          return customerService ? `${locations }（客服：${customerService }）` : locations
        }
        return customerService ? `${row.workLocation }（客服：${customerService }）` : row.workLocation
      }
      return '-'
    },
    getPolicies(childRow) {
      if (childRow.policies && Array.isArray(childRow.policies)) {
        return childRow.policies
      }
      const policyData = this.getPolicyDataFromMap(childRow.policyNo)
      return [{
        policyNo: childRow.policyNo,
        policyHolder: childRow.policyHolder || policyData.policyHolder,
        insured: childRow.insured || policyData.insured,
        effectiveDate: childRow.effectiveDate || policyData.effectiveDate,
        salesPrice: childRow.salesPrice || policyData.salesPrice,
        insuranceCompany: childRow.insuranceCompany || policyData.insuranceCompany
      }]
    },
    formatArrayValue(value) {
      if (!value) return ''
      if (Array.isArray(value)) return value.join('、')
      return value
    },
    getPolicyDataFromMap(policyNo) {
      const policyDataMap = {
        'POL2024001234': {
          effectiveDate: '2024-01-15',
          salesPrice: '80元/人/月',
          insuranceCompany: '平安保险',
          policyHolder: '北京京东世纪贸易有限公司',
          insured: ['全体员工']
        },
        'POL2024005678': {
          effectiveDate: '2024-02-20',
          salesPrice: '75元/人/月',
          insuranceCompany: '太平洋保险',
          policyHolder: '上海三快科技有限公司',
          insured: ['注册骑手']
        },
        'P001': {
          effectiveDate: '2024-03-10',
          salesPrice: '85元/人/月',
          insuranceCompany: '中国人寿',
          policyHolder: '万宝盛华企业管理有限公司',
          insured: ['员工']
        },
        'P002': {
          effectiveDate: '2024-03-15',
          salesPrice: '78元/人/月',
          insuranceCompany: '新华保险',
          policyHolder: '中智经济技术合作股份有限公司',
          insured: ['员工', '员工及其家属']
        },
        'P003': {
          effectiveDate: '2024-03-20',
          salesPrice: '82元/人/月',
          insuranceCompany: '泰康保险',
          policyHolder: '北京汇智英才信息科技有限公司',
          insured: ['员工']
        },
        'P004': {
          effectiveDate: '2024-04-05',
          salesPrice: '72元/人/月',
          insuranceCompany: '人保财险',
          policyHolder: '软通动力信息技术有限公司',
          insured: ['全体员工']
        },
        'P005': {
          effectiveDate: '2024-04-10',
          salesPrice: '70元/人/月',
          insuranceCompany: '大地保险',
          policyHolder: '顺丰速运有限公司',
          insured: ['分拣员、快递员']
        },
        'P006': {
          effectiveDate: '2024-05-01',
          salesPrice: '88元/人/月',
          insuranceCompany: '阳光保险',
          policyHolder: '拉扎斯网络科技(上海)有限公司',
          insured: ['蜂鸟众包骑手']
        },
        'P007': {
          effectiveDate: '2024-05-05',
          salesPrice: '90元/人/月',
          insuranceCompany: '中华保险',
          policyHolder: '德邦物流股份有限公司',
          insured: ['员工']
        },
        'P008': {
          effectiveDate: '2024-05-10',
          salesPrice: '86元/人/月',
          insuranceCompany: '友邦保险',
          policyHolder: '北京外企人力资源服务有限公司',
          insured: ['员工']
        },
        'P009': {
          effectiveDate: '2024-05-15',
          salesPrice: '84元/人/月',
          insuranceCompany: '招商信诺',
          policyHolder: '美团科技有限公司',
          insured: ['员工']
        }
      }
      return policyDataMap[policyNo] || {
        effectiveDate: '',
        salesPrice: '',
        insuranceCompany: '',
        policyHolder: '',
        insured: []
      }
    },
    showTotalText(total) {
      return `共 ${total} 条`
    },
    getStatusColor(status) {
      switch (status) {
        case '合作中':
          return '#0DD78D'
        case '已终止':
          return '#FF4D4F'
        default:
          return '#999'
      }
    },
    handleToggleExpand({ row }) {
      this.$nextTick(() => {
        if (this.$refs.childTableRef) {
          if (Array.isArray(this.$refs.childTableRef)) {
            this.$refs.childTableRef.forEach(table => {
              if (table && table.updateLayout) {
                table.updateLayout()
              }
            })
          } else if (this.$refs.childTableRef.updateLayout) {
            this.$refs.childTableRef.updateLayout()
          }
        }
      })
    },
    handlePageChange(page) {
      this.currentPage = page
    },
    handlePageSizeChange(current, size) {
      this.pageSize = size
      this.currentPage = 1
    },
    handleEdit(row) {
      this.$emit('handleEdit', row)
    },
    handleView(row) {
      this.$emit('handleView', row)
    },
    handleDelete(row) {
      this.$confirm({
        title: '提示',
        content: '确定要删除该项目吗？',
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          this.$emit('handleDelete', row)
        }
      })
    },
    handleHistoryPolicy(row) {
      this.$emit('handleHistoryPolicy', row)
    },
    handleEnabledChange(childRow) {
      this.$emit('handleChildChange', childRow)
    },
    handleCooperationStatusChange(row, val) {
      row.cooperationStatus = val
      this.$emit('handleCooperationStatusChange', row)
    },
    refreshTable() {
      this.$nextTick(() => {
        if (this.$refs.vxeTableRef && this.$refs.vxeTableRef.updateLayout) {
          this.$refs.vxeTableRef.updateLayout()
        }
      })
    }
  }
}
</script>

<style scoped>
.insurance-table {
  width: 100%;
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  padding: 12px 0;
}

.pagination-wrapper :deep(.ant-pagination-item-active) {
  border-color: #FC6732;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #FC6732;
}

.pagination-wrapper :deep(.ant-pagination-item:hover) {
  border-color: #FC6732;
}

.pagination-wrapper :deep(.ant-pagination-item:hover a) {
  color: #FC6732;
}

.pagination-wrapper :deep(.ant-pagination-prev:hover .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next:hover .ant-pagination-item-link) {
  border-color: #FC6732;
  color: #FC6732;
}

.pagination-wrapper :deep(.ant-pagination-options .ant-select-selection-item) {
  color: #FC6732;
}

.insurance-table :deep(.vxe-body--row.vxe-row--expand) {
  background-color: #fafafa;
}

.expand-detail-wrapper {
  background-color: #fff;
  border: 1px solid #e8e8e8;
}

.expand-detail-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  padding: 12px 16px;
  border-bottom: 1px solid #e8e8e8;
}

.policies-container {
  padding-left: 20px;
}

.policy-item {
  padding: 12px 0;
}

.policy-divider {
  height: 1px;
  background-color: #e8e8e8;
  margin: 8px 0;
}

.policy-item {
  display: flex;
  gap: 16px;
}

.policy-field {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.expand-detail-label {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
}

.expand-detail-value {
  font-size: 13px;
  color: #333;
  word-break: break-all;
}

.link-button {
  background: none;
  border: none;
  color: #516EFD;
  cursor: pointer;
  padding: 0;
  font-size: 13px;
  margin-right: 12px;
}

.link-button:hover {
  color: #FC6732;
  text-decoration: underline;
}

.link-button:last-child {
  margin-right: 0;
}

.link-button.delete-link-button {
  color: #FF4D4F;
}

.link-button.delete-link-button:hover {
  color: #ff7875;
}

@media (max-width: 1200px) {
  .expand-detail-grid.six-cols {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .expand-detail-grid.six-cols {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
